<template>
<div>
<!--    <div id="ec-overlay">-->
<!--        <div class="ec-ellipsis">-->
<!--            <div></div>-->
<!--            <div></div>-->
<!--            <div></div>-->
<!--            <div></div>-->
<!--        </div>-->
<!--    </div>-->

    <!-- Header start  -->
    <header class="ec-header">
        <!--Ec Header Top Start -->
        <div class="header-top ">
            <div class="container">
                <div class="row align-items-center">

                    <a href="#ec-mobile-menu" class="ec-header-btn ec-side-toggle ec-sidebar-toggle d-lg-none">
                        <i class="fi-rr-menu-burger"></i>
<!--                        <i class="fi fi-rr-apps"></i>-->

                    </a>

                    <!-- Header Top Message Start -->
                    <div class="col  header-top-center">
                        <div class="header-top-message ">
                            {{ $t('100 % secure delivery without contacting the courier') }}
                        </div>
                    </div>
                    <!-- Header Top Message End -->
                    <!-- Header Top Language Currency -->
                    <div class="col header-top-right d-none d-lg-block">
                        <div class="header-top-lan-curr d-flex justify-content-end">

                            <!-- Language Start -->
                            <div class="header-top-lan dropdown">
                                <button class="dropdown-toggle" data-bs-toggle="dropdown">
                                    {{ $i18n.locale == 'ar' ? 'Language' : 'اللغة' }}
                                    <i class="fi-rr-angle-small-down"></i></button>
                                <ul class="dropdown-menu">
                                    <li class="active"><a class="dropdown-item" href="/en">English</a></li>
                                    <li><a class="dropdown-item" href="/ar">عربي</a></li>
                                </ul>
                            </div>
                            <!-- Language End -->

                        </div>
                    </div>
                    <!-- Header Top Language Currency -->

                    <!-- Header Top responsive Action -->
                    <div class="col l d-lg-none ">
                        <div class="ec-header-bottons">

                            <user-cp :type="'mobile'"></user-cp>

                            <router-link :to="{name: 'products.favorite', params: { lang : $i18n.locale }}"
                                         class="ec-header-btn ec-header-wishlist">

                                <div class="header-icon"><i class="fi-rr-heart"></i></div>
                                <!--                                    <span class="ec-header-count">4</span>-->
                            </router-link>
<!--                            &lt;!&ndash; Header Cart Start &ndash;&gt;-->
<!--                            <a href="#ec-side-cart" class="ec-header-btn ec-side-toggle">-->
<!--                                <div class="header-icon"><i class="fi-rr-shopping-basket"></i></div>-->
<!--                                <span class="ec-header-count ec-cart-count cart-count-lable">3</span>-->
<!--                            </a>-->
<!--                            &lt;!&ndash; Header Cart End &ndash;&gt;-->

                            <cart-list></cart-list>

                        </div>
                    </div>
                    <!-- Header Top responsive Action -->
                </div>
            </div>
        </div>
        <!-- Ec Header Top  End -->

        <!-- Ec Header Bottom  Start -->
        <div class="ec-header-bottom d-none d-lg-block position-relative">
            <div class="container">
<!--                <div class="banner_image_layout banner_basic_2">-->
<!--                    <img src="images/brand-image/banner.png" class="w-100 mb-4" >-->
<!--                </div>-->
                <div class="row">
                    <div class="ec-flex">
                        <!-- Ec Header Logo Start -->
                        <div class="align-self-center">
                            <div class="header-logo">

                                <router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >
                                    <img :src="main?.settings?.logo" v-if="main?.settings?.logo" :alt="main?.settings?.name" />
                                    <img
                                        class="dark-logo" :src="main?.settings?.logo" v-if="main?.settings?.logo" :alt="main?.settings?.name"
                                        style="display: none;" />
                                </router-link>

                            </div>
                        </div>
                        <!-- Ec Header Logo End -->

                        <!-- EC Main Menu Start -->
                        <div id="ec-main-menu-desk" class="d-none d-lg-block sticky-nav">
                            <div class="container position-relative">
                                <div class="row">
                                    <div class="col-md-12 align-self-center">
                                        <div class="ec-main-menu">
                                            <ul>

                                                <li>
                                                    <router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >
                                                        {{ $t('Home') }}
                                                    </router-link>
                                                </li>
<!--                                                <li>-->
<!--                                                    <router-link :to="{name: 'products.index', params: { lang : $i18n.locale }}" >-->
<!--                                                        المنتجات-->
<!--                                                    </router-link>-->
<!--                                                </li>-->
                                                <li>
                                                    <router-link :to="{name: 'blog_posts.index', params: { lang : $i18n.locale }}" >
                                                        {{  $t('Blog') }}
                                                    </router-link>
                                                </li>

                                                <li class="dropdown"  v-for="section in main?.sections">

                                                    <a href="javascript:void(0)" v-if="section?.categories?.length > 0">{{ section.name }}</a>

                                                    <router-link v-if="section?.categories?.length == 0"
                                                                 :to="{name: 'products.index', params: { lang : $i18n.locale }
                                                                                                    , query: {  'section_ids[]': section.id ,   } }"
                                                                 @click="scrollToTop" class="dropdown-item" >
                                                        {{ section?.name}}
                                                    </router-link>

                                                    <ul class="sub-menu"
                                                        v-if="section?.categories?.length > 0">
                                                        <li  v-for="category in section?.categories">
                                                            <router-link :to="{name: 'products.index', params: { lang : $i18n.locale }
                                                                                                    , query: {  'category_ids[]': category.id ,   } }"
                                                                         @click="scrollToTop" class="dropdown-item" >
                                                                {{ category?.name}}
                                                            </router-link>

                                                        </li>
                                                    </ul>
                                                </li>

                                                <template v-for="page in main?.pages" >
                                                    <li v-if="( page?.menu !== null && page?.menu.includes('navbar') )? true  : false">
                                                        <router-link :to="{name: 'pages.show', params: { id: page.id , lang : $i18n.locale }}"
                                                                     @click="scrollToTop">{{ page.title }}</router-link>
                                                    </li>
                                                </template>

                                                <li>
                                                    <router-link :to="{name: 'contact_us.create' ,  params: {  lang : $i18n.locale }}"
                                                                 @click="scrollToTop">
                                                        {{ $t('Contact us')}}
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Ec Main Menu End -->


                        <user-cp></user-cp>
                    </div>
                </div>
            </div>
        </div>
        <!-- Ec Header Button End -->
        <!-- Ec Header Bottom  Start -->
        <div class="ec-header-bottom d-none d-lg-block">
            <div class="container position-relative">
                <div class="row">
                    <div class="ec-flex">
                        <!-- Header cat Start -->
                        <div class="header-cat-btn ec-dropdown">
                            <button class="dropdown-toggle" data-bs-toggle="dropdown"><i
                                class="fi fi-rr-menu-burger"></i><span>{{ $t('Sections') }}</span><i
                                class="fi fi-rr-angle-small-down"></i></button>
                                <ul class="sub-menu">

                                    <li  v-for="section in main?.sections">
                                        <router-link :to="{name: 'products.index', params: { lang : $i18n.locale }
                                                                                                        , query: {  'section_ids[]': section.id ,   } }"
                                                     @click="scrollToTop" class="dropdown-item" >
                                            {{ section?.name}}
                                        </router-link>

                                    </li>

                                </ul>
                        </div>
                        <!-- Header cat End -->

                        <!-- Ec Header Search Start -->
                        <div class="align-self-center">
                            <div class="header-search">
                                <form class="ec-btn-group-form" :action="`/${this.$i18n.locale}/products`" method="get">
                                    <input class="form-control" :placeholder="$t('input_search')" type="text" name="name">
                                    <button class="submit" type="submit"><i class="fi-rr-search"></i></button>
                                </form>
                            </div>
                        </div>
                        <!-- Ec Header Search End -->

                        <!-- Ec Header Button Start -->
                        <div class="align-self-center">
                            <div class="ec-header-bottons">


                                <router-link :to="{name: 'products.favorite', params: { lang : $i18n.locale }}"
                                             class="ec-header-btn ec-header-wishlist">

                                    <div class="header-icon"><i class="fi-rr-heart"></i></div>
<!--                                    <span class="ec-header-count">4</span>-->
                                </router-link>

                                <cart-list></cart-list>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- Ec Header Button End -->


        <!-- Header responsive Bottom  Start -->
        <div class="ec-header-bottom d-lg-none">
            <div class="container position-relative">
                <div class="row ">

                    <!-- Ec Header Logo Start -->
                    <div class="col">

                        <div class="header-logo">
                            <router-link :to="{name: 'home', params: { lang : $i18n.locale }}" ><img :src="main?.settings?.logo" :alt="main?.settings?.title" /><img
                                class="dark-logo" :src="main?.settings?.logo" :alt="main?.settings?.title"
                                style="display: none;" /></router-link>
                        </div>

                    </div>
                    <!-- Ec Header Logo End -->
                    <!-- Ec Header Search Start -->
                    <div class="col">


                        <div class="header-search">

                            <form class="ec-btn-group-form" :action="`/${this.$i18n.locale}/products`" method="get">
                                <input class="form-control" :placeholder="$t('input_search')" type="text">
                                <button class="submit" type="submit"><i class="fi-rr-search"></i></button>
                            </form>
                        </div>
                    </div>
                    <!-- Ec Header Search End -->
                </div>
            </div>
        </div>
        <!-- Header responsive Bottom  End -->


        <!-- ekka Mobile Menu Start -->
        <div id="ec-mobile-menu" class="ec-side-cart ec-mobile-menu">
            <div class="ec-menu-title">
                <span class="menu_title">القائمة</span>
                <button class="ec-close">×</button>
            </div>
            <div class="ec-menu-inner">
                <div class="ec-menu-content">
                    <ul>
                        <li>
                            <router-link :to="{name: 'home', params: { lang : $i18n.locale }}" class="ec-close">
                                {{ $t('Home') }}
                            </router-link>
                        </li>
<!--                        <li>-->
<!--                            <router-link :to="{name: 'products.index', params: { lang : $i18n.locale }}" >-->
<!--                                المنتجات-->
<!--                            </router-link>-->
<!--                        </li>-->

<!--                        <li><a href="javascript:void(0)">أقسام المنتجات</a>-->
<!--                            <ul class="sub-menu">-->

<!--                                <li v-for="category in main?.categories">-->

<!--                                    <router-link :to="{name: 'products.index', params: { lang : $i18n.locale }  , query: {  'category_ids[]': category.id } }"-->
<!--                                                 @click="scrollToTop" class="ec-footer-link">-->
<!--                                        &lt;!&ndash;                                                <i :class="{'fas' : true , 'fa-angle-right' : $i18n.locale === 'en' ,'fa-angle-left' : $i18n.locale === 'ar' ,}"></i> &ndash;&gt;-->
<!--                                        {{ category?.name}}-->
<!--                                    </router-link>-->

<!--                                </li>-->
<!--                            </ul>-->
<!--                        </li>-->

                        <li>
                            <router-link :to="{name: 'blog_posts.index', params: { lang : $i18n.locale }}"  class="ec-close">
                                {{  $t('Blog') }}
                            </router-link>
                        </li>


                        <li v-for="section in main?.sections">

                            <a href="javascript:void(0)" v-if="section?.categories?.length > 0">{{ section.name }}</a>

                            <router-link v-if="section?.categories?.length == 0"
                                         :to="{name: 'products.index', params: { lang : $i18n.locale }
                                                                                                    , query: {  'section_ids[]': section.id ,   } }"
                                         @click="scrollToTop" class="dropdown-item ec-close" >
                                {{ section?.name}}
                            </router-link>

                            <ul  class="sub-menu"
                                v-if="section?.categories?.length > 0">
                                <li  v-for="category in section?.categories">

                                  <router-link
                                               :to="{name: 'products.index', params: { lang : $i18n.locale }
                                                                                                    , query: {  'section_ids[]': section.id ,   } }"
                                               @click="scrollToTop" class="dropdown-item ec-close text-muted" >
                                    كامل القسم : {{ section?.name}}
                                  </router-link>

                                    <router-link :to="{name: 'products.index', params: { lang : $i18n.locale }
                                                                                                    , query: {  'category_ids[]': category.id ,   } }"
                                                 @click="scrollToTop" class="dropdown-item ec-close">
                                        {{ category?.name}}
                                    </router-link>

                                </li>
                            </ul>
                        </li>

                        <template v-for="page in main?.pages" >
                            <li v-if="( page?.menu !== null && page?.menu.includes('navbar') )? true  : false">
                                <router-link :to="{name: 'pages.show', params: { id: page.id , lang : $i18n.locale }}"  class="ec-close">
                                    {{ page.title }}
                                </router-link>
                            </li>
                        </template>
                        <li>
                            <router-link :to="{name: 'contact_us.create' ,  params: {  lang : $i18n.locale }}"  class="ec-close">
                                {{ $t('Contact us')}}
                            </router-link>
                        </li>
                    </ul>
                </div>
                <div class="header-res-lan-curr">
                    <div class="header-top-lan-curr">


                        <!-- Language Start -->
                        <div class="header-top-lan dropdown">
                            <button class="dropdown-toggle text-upper" data-bs-toggle="dropdown">
                                {{ $i18n.locale == 'ar' ? 'Language' : 'اللغة' }}
                                <i
                                class="ecicon eci-caret-down" aria-hidden="true"></i></button>
                            <ul class="dropdown-menu">
                                <li class="active"><a class="dropdown-item" href="/en">English</a></li>
                                <li><a class="dropdown-item" href="/ar">عربي</a></li>
                            </ul>
                        </div>
                        <!-- Language End -->


                    </div>
                </div>
            </div>
        </div>
        <!-- ekka mobile Menu End -->
    </header>

<!--    <div class="alert alert-info alert-dismissible fade show fixed-alert m-0 rounded-0" role="alert">-->
<!--&lt;!&ndash;        <strong>Warning!</strong>&ndash;&gt;-->
<!--        الطلبات التي سيتم طلبها من الموقع والتطبيق-->
<!--        بداية من يوم الثلاثاء الموافق 04 ذي الحجة سيتم توصيلها بعد اجازة عيد الاضحى المبارك-->

<!--        كل عام وانتم بخير-->

<!--        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>-->
<!--    </div>-->
    <!-- Header End  -->
    <div class="ec-side-cart-overlay" style="display: none;"></div>

    <main>
<!--        <router-view :main="main"-->
<!--                     :key="$route.query ?? $route.path ?? $route.url"-->
<!--        ></router-view>-->
<!--        <router-view :main="main"-->
<!--                     :key="$route.fullPath"-->
<!--        ></router-view>-->
        <router-view :main="main"
                     :key="$route.query"
        ></router-view>
    </main>

<!--    &lt;!&ndash; mobile fix menu start &ndash;&gt;-->
<!--    <div class="mobile-menu d-md-none d-block mobile-cart">-->
<!--        <ul>-->
<!--            <li class="active">-->
<!--                <a href="/">-->
<!--                    <i class="iconly-Home icli"></i>-->
<!--                    <span>{{ $t('Home') }}</span>-->
<!--                </a>-->
<!--            </li>-->

<!--            <li class="mobile-category">-->
<!--                <a type="button"-->
<!--                        data-bs-toggle="offcanvas" data-bs-target="#primaryMenu">-->

<!--                    <i class="iconly-Category icli js-link"></i>-->
<!--                    <span>{{ $t('Menu') }}</span>-->
<!--                </a>-->
<!--            </li>-->

<!--            <li>-->
<!--                <router-link :to="{name: ! auth.isLoggedIn() ? 'login' :'cart_items.index', params: { lang : $i18n.locale  }}">-->
<!--                    <i class="iconly-Bag-2 icli fly-cate"></i>-->
<!--                    <span>{{ $t('Cart')}}</span>-->
<!--                </router-link>-->
<!--            </li>-->
<!--        </ul>-->
<!--    </div>-->
<!--    &lt;!&ndash; mobile fix menu end &ndash;&gt;-->

    <!-- footer sec start -->
    <footer class="section ec-footer-sec">
        <div class="footer-container ec-footer">
            <div class="footer-top section-space-footer-p">
                <div class="container">
<!--                    <div class="social-links">-->
<!--                        <a href="" class="social-btn">Facebook</a>-->
<!--                        <a href="" class="social-btn">Twitter</a>-->
<!--                        <a href="" class="social-btn">Instagram</a>-->
<!--                        <a href="" class="social-btn">Linkedin</a>-->
<!--                        <a href="" class="social-btn">Google</a>-->
<!--                        <a href="" class="social-btn">Youtube</a>-->
<!--                    </div>-->

                    <div class="row">

                        <div class="col-md-3 ec-footer-cat">
                            <div class="ec-footer-widget">

                                <a href="/" class="footer-logo text-start">
                                    <img :src="main?.settings?.logo"  class="me-auto" alt="">
                                    <img :src="main?.settings?.logo"  class="dark-logo me-auto" style="display: none">
                                </a>
                                <p class="">
                                    {{ main?.settings?.about }}
                                </p>
                            </div>
                        </div>

                        <div class="col-sm-12 col-lg-3 ec-footer-cat">
                            <div class="ec-footer-widget">
                                <h4 class="ec-footer-heading"> {{ $t('Important links')}} </h4>
                                <div class="ec-footer-links ec-footer-dropdown">
                                    <ul class="align-items-center">

                                        <li class="ec-footer-link">
                                            <router-link :to="{name: 'products.index', params: { lang : $i18n.locale }}" >
                                                <i :class="{'fas' : true , 'fa-angle-right' : $i18n.locale === 'en' ,'fa-angle-left' : $i18n.locale === 'ar' ,}" class="me-1"></i>
                                                {{ $t('Products') }}
                                            </router-link>
                                        </li>
                                        <li class="ec-footer-link">
                                            <router-link :to="{name: 'blog_posts.index', params: { lang : $i18n.locale }}" >
                                                <i :class="{'fas' : true , 'fa-angle-right' : $i18n.locale === 'en' ,'fa-angle-left' : $i18n.locale === 'ar' ,}" class="me-1"></i>
                                                {{ $t('Blog') }}
                                            </router-link>
                                        </li>
                                        <li class="ec-footer-link">
                                            <router-link :to="{name: 'faqs.index' , params: {  lang : $i18n.locale }}" @click="scrollToTop">
                                                <i :class="{'fas' : true , 'fa-angle-right' : $i18n.locale === 'en' ,'fa-angle-left' : $i18n.locale === 'ar' ,}" class="me-1"></i>
                                                {{ $t('common questions')}}
                                            </router-link>
                                        </li>


                                        <template v-for="page in main?.pages" >
                                            <li
                                                class="ec-footer-link"
                                                v-if="( page?.menu !== null && page?.menu.includes('footer') )? true  : false">
                                                <router-link :to="{name: 'pages.show', params: { id: page.id , lang : $i18n.locale }}"  @click="scrollToTop" >
                                                    <i :class="{'fas' : true , 'fa-angle-right' : $i18n.locale === 'en' ,'fa-angle-left' : $i18n.locale === 'ar' ,}" class="me-1"></i>
                                                    {{ page.title }}
                                                </router-link>
                                            </li>
                                        </template>

                                        <li  class="ec-footer-link">
                                            <router-link :to="{name: 'contact_us.create' , params: { lang : $i18n.locale }}" @click="scrollToTop" >
                                                <i :class="{'fas' : true , 'fa-angle-right' : $i18n.locale === 'en' ,'fa-angle-left' : $i18n.locale === 'ar' ,}" class="me-1"></i>
                                                {{ $t('Contact us')}}
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-lg-2 ec-footer-cat">
                            <div class="ec-footer-widget">
                                <h4 class="ec-footer-heading">{{ $t('Sections') }}</h4>
                                <div class="ec-footer-links ec-footer-dropdown">
                                    <ul class="align-items-center">
                                        <li v-for="section in main?.sections">

                                            <router-link :to="{name: 'products.index', params: { lang : $i18n.locale }  , query: {  'section_ids[]': section.id } }"
                                                         @click="scrollToTop" class="ec-footer-link">
                                                <i :class="{'fas' : true , 'fa-angle-right' : $i18n.locale === 'en' ,'fa-angle-left' : $i18n.locale === 'ar' ,}" class="me-1"></i>
                                                {{ section?.name}}
                                            </router-link>

                                            <!-- <ul class="align-items-center ms-3 mb-2"
                                            v-if="section?.categories?.length > 0">
                                                <li v-for="category in section?.categories">
                                                    <router-link
                                                        :to="{name: 'products.index', params: { lang : $i18n.locale }  , query: {  'category_ids[]': category.id } }"
                                                        @click="scrollToTop" class="ec-footer-link">
                                                        <i :class="{'fas' : true , 'fa-angle-right' : $i18n.locale === 'en' ,'fa-angle-left' : $i18n.locale === 'ar' ,}"
                                                           class="me-1"></i>
                                                        {{ category?.name }}
                                                    </router-link>
                                                </li>
                                            </ul> -->
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-lg-4 ec-footer-cat">
                            <div class="ec-footer-widget">
                                <h4 class="ec-footer-heading">{{ $t('Connect with us')}}</h4>
                                <div class="ec-footer-links ec-footer-dropdown">

                                    <ul class="align-items-center mb-3 social-icons">
                                        <li v-for="social_item in main?.social" class="list-inline-item">
                                            <a :href="social_item.url" target="_blank">
                                                <i :class="'fa-brands fa-' + social_item.icon"></i>
                                            </a>
                                        </li>
                                    </ul>


<!--                                    <div class="footer-title">-->
<!--                                        <h4>{{ $t('contact information')}}</h4>-->
<!--                                    </div> -->

                                    <ul class="align-items-center">
                                         <li class="ec-footer-link" v-for="data in main?.contact_data">
                                             <b><i :class="'  me-2 text-muted ' + data.icon"></i> {{ data?.name }} :  </b>
                                             <a :href="data?.href" >
                                                  {{ data?.value }}
                                             </a>
                                         </li>
                                     </ul>

                                    <div class=" mt-sm-4 mt-3 mb-4 " v-if="main?.settings?.app_store_url && main?.settings?.google_play_url ">
                                        <ul class="d-flex gap-3">
                                            <li>
                                                <a :href="main?.settings?.google_play_url" target="_blank">
                                                    <img src="/images/playstore.svg" class="blur-up lazyload" width="150">
                                                </a>
                                            </li>
                                            <li>
                                                <a :href="main?.settings?.app_store_url" target="_blank">
                                                    <img src="/images/appstore.svg" class="blur-up lazyload" width="150">
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="footer-bottom">
                <div class="container">
                    <div class="row ">
                        <!-- Footer payment -->
                        <div class="footer-bottom-right row  p-0">
                            <div class="col-md-6">
                                <div class="payment-link">
                                    <img src="/images/more/telr.png" alt="" height="32">
                                    <img class="made_by" src="/images/brand-image/logo_sena3a_saduia.svg" >
                                </div>
                            </div>
                            <div class="col-md-6 registrationـnumber text-end pt-2 p-0">
                                <span>{{ $t('VAT') }} :</span><strong class="font-weight-bold">311667009300003</strong>
                                <span> | {{ $t('C.R') }} : </span><strong class="font-weight-bold">1010884006</strong>
                            </div>
                        </div>
                        <!-- Footer payment -->
                    </div>
                </div>
            </div>
            <!-- Footer Copyright Start -->
            <div class="container">
                <div class="footer-copy">
                    <div class="row">
                        <div class="col-12">
                            <div class="footer-bottom-copy text-center">
                                <div class="ec-copy">
                                    {{ $t('all rights are save') }} 2024.
                                </div>
                            </div>
                        </div>
<!--                        <div class="col-6">-->
<!--                            <div class="footer">-->
<!--                                <div class="float-end">-->
<!--                                    <a href="https://imockup.net/" target="_blank" class=" text-muted">-->
<!--                                        {{ $t('Designed by') }} imockup.net-->
<!--                                    </a>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>
                </div>
                <!-- Footer Copyright End -->
            </div>
        </div>
    </footer>
    <!-- footer sec End -->

    <!-- Footer navigation panel for responsive display -->
    <div class="ec-nav-toolbar">
        <div class="container">
            <div class="ec-nav-panel">
                <div class="ec-nav-panel-icons">
                    <a href="#ec-mobile-menu" class="navbar-toggler-btn ec-header-btn ec-side-toggle"><i
                        class="fi fi-rr-menu-burger"></i></a>
                </div>

<!--                <div class="ec-nav-panel-icons">-->
<!--                    <user-cp :type="'mobile'"></user-cp>-->
<!--                </div>-->


                <div class="ec-nav-panel-icons">
                <router-link :to="{name: 'products.favorite', params: { lang : $i18n.locale }}"
                             class="ec-header-btn ec-header-wishlist">

                    <div class="header-icon"><i class="fi-rr-heart"></i></div>
                    <!--                                    <span class="ec-header-count">4</span>-->
                </router-link>
                </div>



                <cart-mobile-list></cart-mobile-list>


                <div class="ec-nav-panel-icons">
                    <router-link :to="{name: 'home', params: { lang : $i18n.locale }}"
                                 class="ec-header-btn">
                        <i class="fi-rr-home"></i>
                    </router-link>
                </div>
<!--                <div class="ec-nav-panel-icons">-->
<!--                    <a href="login.html" class="ec-header-btn"><i class="fi-rr-user"></i></a>-->
<!--                </div>-->
            </div>
        </div>
    </div>
    <!-- Footer navigation panel for responsive display end -->

    <!-- Add to Cart successfully toast Start -->
    <div id="addtocart_toast" class="addtocart_toast">
        <div class="desc">You Have Add To Cart Successfully</div>
    </div>
    <div id="wishlist_toast" class="wishlist_toast">
        <div class="desc">You Have Add To Wishlist Successfully</div>
    </div>
    <!-- Add to Cart successfully toast end -->
</div>


    <modal-login :type="'mobile'"></modal-login>
</template>

<script>

import CartList from "./components/cart_item/CartList.vue";
import CartMobileList from "./components/cart_item/CartMobileList.vue";
import UserCp from "./components/auth/user-cp.vue";
import ModalLogin from "./components/auth/modal-login.vue";

export default {
    name: "app",
    components: {
        ModalLogin,
        CartList,
        CartMobileList,
        UserCp,
    },
    inject: ['auth'],
    data() {
        return {
            // currentLocale: '',
            main: [],
        }
    },
    async created() {
        await this.getMain();

        this.runSliders();
    },
    methods: {
        scrollToTop() {
            window.scrollTo(0,0);
        },
        runSliders() {
            setTimeout(function () {



                (function () {
                    var $ecartToggle = $(".ec-side-toggle"),
                        $ecart = $(".ec-side-cart"),
                        $ecMenuToggle = $(".mobile-menu-toggle");

                    $ecartToggle.on("click", function (e) {
                        e.preventDefault();
                        var $this = $(this),
                            $target = $this.attr("href");
                        // $("body").addClass("ec-open");
                        $(".ec-side-cart-overlay").fadeIn();
                        $($target).addClass("ec-open");
                        if ($this.parent().hasClass("mobile-menu-toggle")) {
                            $this.addClass("close");
                            $(".ec-side-cart-overlay").fadeOut();
                        }
                    });

                    $(".ec-side-cart-overlay").on("click", function (e) {
                        $(".ec-side-cart-overlay").fadeOut();
                        $ecart.removeClass("ec-open");
                        $ecMenuToggle.find("a").removeClass("close");
                    });

                    $(".ec-close").on("click", function (e) {
                        e.preventDefault();
                        $(".ec-side-cart-overlay").fadeOut();
                        $ecart.removeClass("ec-open");
                        $ecMenuToggle.find("a").removeClass("close");
                    });

                    $("body").on("click", ".ec-pro-content .remove", function () {

                        // $(".ec-pro-content .remove").on("click", function () {

                        var cart_product_count = $(".eccart-pro-items li").length;

                        $(this).closest("li").remove();
                        if (cart_product_count == 1) {
                            $('.eccart-pro-items').html('<li><p class="emp-cart-msg">Your cart is empty!</p></li>');
                        }

                        var count = $(".ec-cart-count").html();
                        count--;
                        $(".ec-cart-count").html(count);

                        cart_product_count--;
                    });

                })();

                /*--------------------- ecart Responsive Menu -----------------------------------*/

                /*--------------------- ecart Responsive Menu -----------------------------------*/
                function ResponsiveMobileEcartMenu() {
                    var $ecartNav = $(".ec-menu-content, .overlay-menu"),
                        $ecartNavSubMenu = $ecartNav.find(".sub-menu");
                    $ecartNavSubMenu.parent().prepend('<span class="menu-toggle"></span>');

                    $ecartNav.on("click", "li a, .menu-toggle", function (e) {
                        var $this = $(this);
                        if ($this.attr("href") === "#" || $this.hasClass("menu-toggle")) {
                            e.preventDefault();
                            if ($this.siblings("ul:visible").length) {
                                $this.parent("li").removeClass("active");
                                $this.siblings("ul").slideUp();
                                $this.parent("li").find("li").removeClass("active");
                                $this.parent("li").find("ul:visible").slideUp();
                            } else {
                                $this.parent("li").addClass("active");
                                $this.closest("li").siblings("li").removeClass("active").find("li").removeClass("active");
                                $this.closest("li").siblings("li").find("ul:visible").slideUp();
                                $this.siblings("ul").slideDown();
                            }
                        }
                    });
                }
                ResponsiveMobileEcartMenu();


            },350);

        },
        async getMain() {
            await axios.get('main').then(response => {
                // toast.success("content loading...", {
                //     timeout: 2000
                // });
                this.main = response.data?.data;
                // this.currentLocale = response.data?.data?.lang;
                // this.$i18n.locale = this.currentLocale;
                // console.log(this.currentLocale);

            });
        },
    },
}
</script>
<style>

.fixed-alert {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1050; /* Ensure it's above other elements */

    color: #842029;
    background-color: #f8d7da;
    border-color: #f5c2c7;
}
</style>
